import React from "react";
import styled from "styled-components";

const Err = styled.div`
	color: red;
	padding: 10px;
	border-radius: 10px;
	border: 0.5px solid red;
	margin-bottom: 1rem;
	margin-top: 1rem;
	font-family: Roboto;
`;

function Error({ ...props }) {
	return <React.Fragment>{props.text != undefined && props.text != "undefined" && <Err>{props.text}</Err>}</React.Fragment>;
}

export default Error;
